@if (loading$ | async) {
  <div id="loaderitem" class="loaderitem">
  </div>
}
@if (loading$ | async) {
  <div class="loader-content">
    <img class="loader-content__seat-loader" src="assets/images/seat-loader.svg">
  </div>
}